<div class="table-container">

  <div class="nr-form-group" *ngIf="enableSearch">
    <input class="common-text-box" placeholder="Search..." autocomplete="off" [ngModel]="filterText"
      (ngModelChange)="applyFilter($event)" />
  </div>

  <mat-table #table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container *ngFor="let col of headerColumns" matColumnDef="{{col}}">
      <mat-header-cell *matHeaderCellDef>
        {{ (col === 'eqDesc' ? 'Equipment Description' : col) | uppercase }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <mat-radio-button *ngIf="col === 'select'" (click)="onRadioSelected(element)"></mat-radio-button>
        <img *ngIf="col === 'eqDesc' && element['eqDesc'].includes(':GA:')" src="assets/images/asset-golden.svg" alt="" />
        <img *ngIf="col === 'eqDesc' && element['eqDesc'].includes(':UV:')" src="assets/images/asset-uv.svg" alt="" />
        {{ col !== 'eqDesc' ? element[col]
        : element['eqDesc'].includes(':GA:') ? element['eqDesc'].replace(':GA:','')
        : element['eqDesc'].includes(':UV:') ? element['eqDesc'].replace(':UV:','') : element[col] }}
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="headerColumns" class="mat-header"></mat-header-row>
    <mat-row *matRowDef="let row; columns: headerColumns;"></mat-row>
  </mat-table>

  <mat-paginator #paginator *ngIf="showPagination && pageWiseApi" [length]="pageLength" [pageIndex]="pageIndex"
    [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)">
  </mat-paginator>
  <mat-paginator #paginator *ngIf="showPagination && !pageWiseApi" [pageIndex]="pageIndex" [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions">
  </mat-paginator>

  <div class="common-filter-control align-center {{ fromEqSearch ? 'sticky' : '' }}" fxLayout="row" fxLayoutGap="5px">
    <div fxLayout="column" fxFlex="70" fxLayoutAlign="center center" class="err-meaasge" *ngIf="message">
      Equipment is already added to the failure record
    </div>
    <div fxLayout="column" fxFlex fxLayoutAlign="end end" fxLayoutGap="15px" *ngIf="selectButttonName">
      <button class="common-button nr-button-active" type="submit" (click)="sendToParent()">
        {{selectButttonName}}
      </button>
    </div>
  </div>

</div>